import {createSlice} from '@reduxjs/toolkit';

export const loginSlice = createSlice({
    name: "loginData",
    initialState: { value: {
        token: -1,
        refToken:  -1
    } },
    reducers: {
        loginData: (state, action) => {
            state.value = action.payload
        },
    }
});

export const { loginData } = loginSlice.actions;

export default loginSlice.reducer;